module.exports = __webpack_public_path__ + "img/icon_two_section_103.2c09d2e3.png";